// import { FaStar, FaStarHalfAlt, FaHeart, FaArrowRight } from "react-icons/fa";
// import { MdVerified } from "react-icons/md";
// import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
// import StarIcon from "@mui/icons-material/Star";
// import { useState } from "react";
// import { IconButton } from "@mui/material";
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import { FaRegHeart } from "react-icons/fa";
// import axiosInstance from "../../../configuration/request";
// import { useSnackbar } from "../../../component/SnackbarContext";
// import { useSelector } from "react-redux";
// import './style/storeCard.css'

// const StoreCard = ({
//   laundry,
//   isOrderNow = true,
//   handleOrder,
//   onCardSelect,
//   selected = false,
//   updateFavorit,
//   showEstimate = false,
// }) => {
//   const { loginDetails } = useSelector((state) => state.counter);
//   const userId = loginDetails.userId || null;
//   const isImageAvailable = !!laundry?.image;
//   const showSnackbar = useSnackbar();

//   const handleCardClick = () => {
//     if (!isOrderNow) {
//       if (onCardSelect) {
//         onCardSelect(laundry);
//       }
//     }
//   };

//   const onFavoriteToggle = (id, isFavorite) => {
//     if (isFavorite) {
//       // REMOVE from favorite
//       axiosInstance
//         .delete(`/customer/store/favorite/${userId}?storeId=${id}`)
//         .then(() => {
//           showSnackbar("Removed from favorites", "success");
//           updateFavorit();
//         })
//         .catch((error) => {
//           showSnackbar(
//             error?.response?.data?.message || "Something went wrong!",
//             "error"
//           );
//         });
//     } else {
//       axiosInstance
//         .patch(`/customer/store/favorite/${userId}?storeId=${id}`)
//         .then(() => {
//           showSnackbar("Added to favorites", "success");
//           updateFavorit();
//         })
//         .catch((error) => {
//           showSnackbar(
//             error?.response?.data?.message || "Something went wrong!",
//             "error"
//           );
//         });
//     }
//   };

//   return (
//     <div
//       onClick={handleCardClick}
//       className={`flex flex-col bg-[var(--card-bg)] rounded-2xl h-full p-3 relative overflow-hidden border w-full transition-colors cursor-pointer ${selected
//           ? "border-[2px] border-[#008ECC] shadow-[0_0_14px_#008ecc33]"
//           : "border-[var(--card-border)] shadow-lg"
//         }`}
//     >
//       {/* Image */}
//       <div className="relative">
//         <div className="w-full h-24 md:h-40 bg-[#E8F3F8] rounded-xl flex items-center justify-center overflow-hidden mb-3">
//           {isImageAvailable ? (
//             <img
//               src={laundry.image}
//               alt="Laundry"
//               className="w-full h-full object-cover"
//             />
//           ) : (
//             <LocalLaundryServiceIcon
//               style={{ fontSize: 80 }}
//               className="text-[#3383B2]"
//             />
//           )}
//         </div>

//         <div className="absolute top-3 right-3">
//           <IconButton
//             onClick={() => onFavoriteToggle(laundry.id, laundry.isFavorite)}
//             size="small"
//           >
//             {laundry.isFavorite ? (
//               <FaHeart className="text-[var(--card-heart)] text-lg md:text-xl" />
//             ) : (
//               <FaRegHeart className="text-gray-400 text-xl" />
//             )}
//           </IconButton>
//         </div>

//         {/* <FaHeart className="absolute top-3 right-3 text-[var(--card-heart)] text-xl" /> */}
//         {laundry?.preferred && (
//           <div className="absolute bottom-4 right-2 bg-[var(--card-verified-bg)] text:xs sm:text-sm rounded-[6px] px-2 py-1 flex items-center gap-1 shadow-sm backdrop-blur-lg">
//             <MdVerified className="text-[var(--card-verified-icon)] font-bold text-sm sm:text-sm" />
//             <span className="text-[var(--card-verified-text)] font-medium">
//               TYDII
//             </span>
//           </div>
//         )}
//       </div>

//       <div
//         className={`flex flex-wrap  mb-1 ${showEstimate ? "justify-between" : "justify-center"
//           }`}
//       >
//         <h5 className="font-semibold text:sm md:text-lg text-[var(--card-title)] text-center ">
//           {laundry.title}
//         </h5>

//         {showEstimate && (
//           <div className="flex items-center bg-[#02537F] text-white text-xs font-[600] py-[2px] px-2 rounded-md">
//             Est. ${laundry.totalPrice}
//           </div>
//         )}
//       </div>

//       {/* Rating */}
//       <div className="flex justify-center gap-1 items-center text-sm  md:text-base mb-2">
//         {[...Array(5)].map((_, i) => (
//           <StarIcon
//             key={i}
//             fontSize="small"
//             sx={{
//               color: i < laundry.rating ? "var(--card-rating)" : "#e5e7eb",
//             }}
//           />
//         ))}
//       </div>

//       {/* Time Slot */}
//       <div className="bg-[var(--card-time-bg)] text-[var(--card-time-text)] text-xs md:text-sm font-[600] w-fit mx-auto px-3 py-1 rounded-lg mb-2">
//         {laundry?.time?.open && laundry?.time?.close
//           ? `${laundry.time.open} - ${laundry.time.close}`
//           : "Closed"}
//       </div>

//       {/* Description */}
//       {/* <p className="text-center  text-base text-[var(--card-desc)] mb-3">
//         {laundry.description}
//       </p> */}

//       {/* Tags */}
//       <div className="tag-scroller mb-4">
//         <div
//           className="tag-scroller__track"
//           style={{ "--tag-speed": "22s" }} // slower/faster: e.g. 35s or 15s
//         >
//           {/* set A */}
//           {laundry?.services?.map((tag, i) => (
//             <span
//               key={`a-${i}`}
//               className="flex-shrink-0 border border-[var(--card-tag-border)] text-[var(--card-tag-text)] px-3 py-1 text-xs md:text-sm rounded-[6px] font-[700]"
//             >
//               {tag}
//             </span>
//           ))}

//           {/* set B (duplicate) */}
//           {laundry?.services?.map((tag, i) => (
//             <span
//               key={`b-${i}`}
//               className="flex-shrink-0 border border-[var(--card-tag-border)] text-[var(--card-tag-text)] px-3 py-1 text-xs md:text-sm rounded-[6px] font-[700]"
//             >
//               {tag}
//             </span>
//           ))}
//         </div>
//       </div>


//       {/* Button */}
//       {isOrderNow && (
//         <button
//           onClick={() => handleOrder()}
//           className="mt-auto w-full bg-[var(--card-btn-bg)] text-white rounded-[8px] py-[6px] text-xs md:text-sm font-medium flex items-center justify-between gap-2 px-3"
//         >
//           Order Now
//           <span className="w-[20px] h-[20px] md:w-[26px] md:h-[26px] flex justify-center items-center bg-[var(--card-btn-icon-bg)] text-[var(--card-btn-icon-text)] rounded-full">
//             <FaArrowRight />
//           </span>
//         </button>
//       )}
//     </div>
//   );
// };

// export default StoreCard;


import { FaStar, FaStarHalfAlt, FaHeart, FaArrowRight } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import StarIcon from "@mui/icons-material/Star";
import { useState } from "react";
import { IconButton } from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { FaRegHeart } from "react-icons/fa";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";
import { useSelector } from "react-redux";
import './style/storeCard.css'
import { useLocation } from "react-router-dom";

const StoreCard = ({
  laundry,
  isOrderNow = true,
  handleOrder,
  onCardSelect,
  selected = false,
  updateFavorit,
  showEstimate = false,
}) => {
  const location = useLocation();
  const { loginDetails } = useSelector((state) => state.counter);
  const userId = loginDetails.userId || null;
  const isImageAvailable = !!laundry?.image;
  const showSnackbar = useSnackbar();
  const isOpen = laundry?.time?.open && laundry?.time?.close;

    const handleCardClick = () => {
    if (!isOrderNow) {
      if (onCardSelect) {
        onCardSelect(laundry);
      }
    }
  };

  const onFavoriteToggle = (id, isFavorite) => {
    if (isFavorite) {
      // REMOVE from favorite
      axiosInstance
        .delete(`/customer/store/favorite/${userId}?storeId=${id}`)
        .then(() => {
          showSnackbar("Removed from favorites", "success");
          updateFavorit();
        })
        .catch((error) => {
          showSnackbar(
            error?.response?.data?.message || "Something went wrong!",
            "error"
          );
        });
    } else {
      axiosInstance
        .patch(`/customer/store/favorite/${userId}?storeId=${id}`)
        .then(() => {
          showSnackbar("Added to favorites", "success");
          updateFavorit();
        })
        .catch((error) => {
          showSnackbar(
            error?.response?.data?.message || "Something went wrong!",
            "error"
          );
        });
    }
  };
    const shopPage = "/shop-selection";
  const isCursor = shopPage === location.pathname

  return (
    <div
      onClick={handleCardClick}
        className={`flex flex-col bg-[var(--card-bg)] rounded-2xl h-full p-3 relative overflow-hidden border w-full transition-colors
           ${isCursor ? "cursor-pointer " : ""}
        ${selected ? "border-[2px] border-[#008ECC] shadow-[0_0_14px_#008ecc33]" : "border-[var(--card-border)] shadow-lg"}
        ${!isOpen ? "opacity-90 " : ""}`}
    >
      {/* Image */}
      <div className="relative">
        <div className="w-full h-24 md:h-40 bg-[#E8F3F8] rounded-xl flex items-center justify-center overflow-hidden mb-3">
          {isImageAvailable ? (
            <img
              src={laundry.image}
              alt="Laundry"
              className="w-full h-full object-cover"
            />
          ) : (
            <LocalLaundryServiceIcon
              style={{ fontSize: 80 }}
              className="text-[#3383B2]"
            />
          )}
        </div>

        <div className="absolute top-3 right-3">
          <IconButton
            onClick={() => onFavoriteToggle(laundry.id, laundry.isFavorite)}
            size="small"
          >
            {laundry.isFavorite ? (
              <FaHeart className="text-[var(--card-heart)] text-lg md:text-xl" />
            ) : (
              <FaRegHeart className="text-gray-400 text-xl" />
            )}
          </IconButton>
        </div>
        {laundry?.preferred && (
          <div className="absolute bottom-4 right-2 bg-[var(--card-verified-bg)] text:xs sm:text-sm rounded-[6px] px-2 py-1 flex items-center gap-1 shadow-sm backdrop-blur-lg">
            <MdVerified className="text-[var(--card-verified-icon)] font-bold text-sm sm:text-sm" />
            <span className="text-[var(--card-verified-text)] font-medium">
              TYDII
            </span>
          </div>
        )}
      </div>

      <div
        className={`flex flex-wrap  mb-1 ${showEstimate ? "justify-between" : "justify-center"
          }`}
      >
        <h5 className="font-semibold text:sm md:text-lg text-[var(--card-title)] text-center ">
          {laundry.title}
        </h5>

        {showEstimate && (
          <div className="flex items-center bg-[#02537F] text-white text-xs font-[600] py-[2px] px-2 rounded-md">
            Est. ${laundry.totalPrice}
          </div>
        )}
      </div>

      {/* Rating */}
      <div className="flex justify-center gap-1 items-center text-sm  md:text-base mb-2">
        {[...Array(5)].map((_, i) => (
          <StarIcon
            key={i}
            fontSize="small"
            sx={{
              color: i < laundry.rating ? "var(--card-rating)" : "#e5e7eb",
            }}
          />
        ))}
      </div>

      {/* Time Slot */}
     <div className="bg-[var(--card-time-bg)] text-[var(--card-time-text)] text-xs md:text-sm font-[600] w-fit mx-auto px-3 py-1 rounded-lg mb-2">
        {isOpen ? `${laundry.time.open} - ${laundry.time.close}` : "Opens Soon"}
      </div>

      {/* Tags */}
      <div className="tag-scroller mb-4">
        <div
          className="tag-scroller__track"
          style={{ "--tag-speed": "22s" }} // slower/faster: e.g. 35s or 15s
        >
          {/* set A */}
          {laundry?.services?.map((tag, i) => (
            <span
              key={`a-${i}`}
              className="flex-shrink-0 border border-[var(--card-tag-border)] text-[var(--card-tag-text)] px-3 py-1 text-xs md:text-sm rounded-[6px] font-[700]"
            >
              {tag}
            </span>
          ))}

          {/* set B (duplicate) */}
          {laundry?.services?.map((tag, i) => (
            <span
              key={`b-${i}`}
              className="flex-shrink-0 border border-[var(--card-tag-border)] text-[var(--card-tag-text)] px-3 py-1 text-xs md:text-sm rounded-[6px] font-[700]"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>


      {isOrderNow && (
        <button
          // onClick={() => isOpen && handleOrder()}
          onClick={() => handleOrder()}

          className={`mt-auto w-full rounded-[8px] py-[6px] text-xs md:text-sm font-medium flex items-center justify-between gap-2 px-3 
            ${isOpen ? "bg-[var(--card-btn-bg)] text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
        >
          Order Now
          <span
            className={`w-[20px] h-[20px] md:w-[26px] md:h-[26px] flex justify-center items-center rounded-full 
              ${isOpen ? "bg-[var(--card-btn-icon-bg)] text-[var(--card-btn-icon-text)]" : "bg-gray-400 text-white"}
              `}
          >
            <FaArrowRight />
          </span>
        </button>
      )}
    </div>
  );
};

export default StoreCard;
